import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useLang } from "../i18n";
import { IMG } from "../content/images";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { Seo } from "../components/Seo";
import { FinalCTA } from "../components/FinalCTA";
import { ArrowRight } from "lucide-react";
import { api } from "../lib/api";

const News = () => {
  const { lang, t, p } = useLang();
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    api.get("/public/posts").then((r) => setPosts(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="news-page">
      <Seo title={t.nav.news} path="actualites" />
      <PageHero eyebrow="BULA TELECOMS SA" title={t.news.title} image={IMG.mastDusk} crumbs={[{ label: t.nav.news }]} />
      <section className="bg-[#F5F5F3]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-16 sm:py-24">
          {posts.length === 0 ? (
            <p className="text-[#101214]/50 text-center" data-testid="news-empty">{t.news.empty}</p>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {posts.map((post, i) => (
                <Reveal key={post.id} delay={(i % 3) * 80}>
                  <Link to={p(`actualites/${post.slug}`)} data-testid={`news-card-${post.slug}`}
                    className="group block h-full bg-white border border-[#101214]/10 rounded-2xl overflow-hidden hover:border-[#FF6600]/50 hover:shadow-[0_12px_40px_rgba(255,102,0,0.1)] transition-all">
                    {post.image_url
                      ? <img src={post.image_url.startsWith("http") ? post.image_url : `${process.env.REACT_APP_BACKEND_URL}/api/files/${post.image_url}`} alt="" loading="lazy" className="w-full aspect-[16/9] object-cover" />
                      : <div className="w-full aspect-[16/9] bg-[#101214] flex items-center justify-center"><span className="font-black text-[#FF6600] text-xl">BULA</span></div>}
                    <div className="p-6">
                      <p className="text-xs font-mono tracking-widest uppercase text-[#FF6600]">{post.category}</p>
                      <h2 className="mt-2 font-bold text-[#101214] leading-snug">{lang === "fr" ? post.title_fr : post.title_en}</h2>
                      <p className="mt-2 text-sm text-[#101214]/60 leading-relaxed line-clamp-3">{lang === "fr" ? post.summary_fr : post.summary_en}</p>
                      <span className="mt-4 inline-flex items-center gap-1.5 text-xs font-black text-[#FF6600] uppercase tracking-wider">
                        {t.news.readMore} <ArrowRight size={13} className="group-hover:translate-x-1 transition-transform" />
                      </span>
                    </div>
                  </Link>
                </Reveal>
              ))}
            </div>
          )}
        </div>
      </section>
      <FinalCTA />
    </div>
  );
};

export default News;
